import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("splide-loop").length >= 1) {
    var splide = new Splide(".splide-loop", {
      type: "loop",
      pagination: false,
      arrows: false,
      autoWidth: true,
      gap: "40px",
      drag: "free",
      snap: false,
      autoScroll: {
        speed: 0.3,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          gap: "20px",
        },
      },
    });
    splide.mount({ AutoScroll });
    // splide.mount();
  }
});
